import React, { Component } from "react";
import {
  Services,
  Slider,
  Statistics,
  Calculation,
  Announcement
} from "./../Components";
class HomePage extends Component {
  render = () => (
    <div>
      <Slider />
      <Statistics />
      <Services />
      <Calculation />
      <Announcement />
    </div>
  );
}
export default HomePage;
